import { useCallback } from 'react';
import { OrderTypes } from 'shell/constants/order-types';
import { Order } from 'shell/view-models/order';
import { HeadCell } from 'shell/components/shared/table/types';

export type OrderFound = {
  exist: boolean;
  value: OrderTypes | undefined;
};

export const useOrder = <T, K extends keyof T>(
  orders: Order
): ((head: HeadCell<T, K>) => OrderFound) => {
  const getOrder = useCallback(
    (headCell: HeadCell<T, K>) => {
      const ordersSort = orders || {};

      const keyOrderFound: string | undefined = (Object.keys(ordersSort) as Array<string>).find(
        (keyOrder) => keyOrder === headCell.id
      );
      const key = keyOrderFound as string;
      return {
        exist: !!key && !!ordersSort[key],
        value: ordersSort[key],
      };
    },
    [orders]
  );

  return getOrder;
};
